import type { ModelLinkOptions } from "./model-link.type";
import type { ModelKey } from "@/modules/model";

import { generatePath } from "react-router";

import { getModelRoute } from "@/modules/model";
import { isValidId } from "@/utilities/id";
import { getIntValue } from "@/utilities/number";

export const getModelLink = (
  model: ModelKey,
  { context, id: idParam, search }: ModelLinkOptions = {}
) => {
  const id = getIntValue(idParam ?? "");

  const routeKey = isValidId(id) ? "item" : "list";
  const route = getModelRoute(model, routeKey);

  if (!route) return "";

  const params = { context: context ?? "", id: `${id}` };
  const path = generatePath(route, params);

  return search ? `${path}${search}` : path;
};
